import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The hover controls of a grid — one compact "Structure" dropdown, where every
 * other entity has a pencil and a menu beside it. Split out of
 * `web-item-controls`, which grew this second layout behind an `isGridControls`
 * flag; nothing here can be locked, so it takes no disabling inputs.
 */
@Component({
    selector: 'web-grid-controls',
    templateUrl: './grid-controls.component.html',
    styleUrls: ['./grid-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TranslateModule],
})
export class GridControlsComponent {
    public readonly selectEvent = output<void>();
    public readonly copyEvent = output<void>();
    /** Adds a widget or a nested structure into the grid. */
    public readonly addEvent = output<void>();
    public readonly deleteEvent = output<void>();
    public readonly toggleMoreActionState = output<boolean>();

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public copyAction(): void {
        this.copyEvent.emit();
    }

    public addAction(): void {
        this.addEvent.emit();
    }

    public deleteAction(): void {
        this.deleteEvent.emit();
    }

    public isShowDropDownMenu(state: boolean): void {
        this.toggleMoreActionState.emit(state);
    }
}
